import React, { Component, Fragment } from 'react'
import { action, observable, computed } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import withWidth, { isWidthUp } from 'material-ui/utils/withWidth'
import inject from 'helpers/inject'

import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Drawer from 'material-ui/Drawer'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import Menu, { MenuItem } from 'material-ui/Menu'
import List from 'material-ui/List'
import { AccountCircle, Close, Menu as MenuIcon } from 'mdi-material-ui'
import NavListItem from 'components/NavListItem'

import AuthService from 'services/auth'
import RouterService from 'services/router'

import { ProfileRoute } from 'routes/config'

import withAppStore from 'decorators/withAppStore'

import styles from 'styles/components/Header'

@withStyles(styles)
@withWidth()
@withAppStore
@observer
export default class Header extends Component {

  auth = inject(AuthService)
  router = inject(RouterService)

  @observable menuTarget
  @observable isDrawerToggledOpen = false

  @computed
  get isDrawerPersistent() {
    return isWidthUp('lg', this.props.width)
  }

  @computed
  get isDrawerOpen() {
    return this.isDrawerPersistent || this.isDrawerToggledOpen
  }

  render() {
    const { classes } = this.props
    const { pageTitle, currentUser } = this.appStore
    const { firstName, lastName } = currentUser || {}

    return (
      <Fragment>
        <AppBar position="fixed" elevation={2}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={ this.handleDrawerToggle }
              className={ classes.navIcon }
            >
              { this.isDrawerToggledOpen ? (
                <Close />
              ) : (
                <MenuIcon />
              )}
            </IconButton>
            <Typography type="title" className={ classes.title } >
              { pageTitle }
            </Typography>
            { this.auth.isAuthorized ? (
              <Fragment>
                <Button color='inherit' onClick={ this.handleMenuOpen } >
                  <AccountCircle className={ classes.icon } /> { firstName } { lastName }
                </Button>
                <Menu
                  anchorEl={ this.menuTarget }
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  open={ !!this.menuTarget }
                  onClose={ this.handleMenuClose }
                  PaperProps={{
                    style: { minWidth: '200px' }
                  }}
                >
                  <MenuItem onClick={ this.handleProfileClick } >Профиль</MenuItem>
                  <MenuItem onClick={ this.handleLogout }>Выйти</MenuItem>
                </Menu>
              </Fragment>
            ) : (
              <Button href='/#/auth?login' color='inherit' >Войти</Button>
            )}
          </Toolbar>
        </AppBar>
        <Drawer
          type="persistent"
          open={ this.isDrawerOpen }
          onClose={ this.handleDrawerToggle }
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <List >
            { this.router.routes.filter(route => route.hasNavLink).map(( route, index ) => (
              <NavListItem
                key={ index }
                route={ route }
                onClick={ this.handleNavClick }
              />
            ))}
          </List>
        </Drawer>
      </Fragment>
    );
  }

  @action.bound
  handleMenuOpen({ currentTarget }) {
    this.menuTarget = currentTarget
  }

  @action.bound
  handleMenuClose() {
    this.menuTarget = null
  }

  @action.bound
  handleLogout() {
    this.handleMenuClose()
    this.auth.logout()
  }

  @action.bound
  handleProfileClick() {
    this.handleMenuClose()
    this.router.transitionTo(ProfileRoute)
  }

  @action.bound
  handleDrawerToggle() {
    this.isDrawerToggledOpen = !this.isDrawerToggledOpen
  }

  @action.bound
  handleNavClick() {
    this.isDrawerToggledOpen = false;
  }

}



// WEBPACK FOOTER //
// ./src/components/Header.js